import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-order-page',
    templateUrl: './common-order-page.component.html',
    styleUrls: ['./common-order-page.component.scss'],
    standalone: false
})
export class CommonOrderPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
